<template>
<div class="container2" id="dataScreen3" >
    <el-row>
      <el-col :span="7">
          <div class="content-left">
          <div class="chart-box">
              <p>专利指标比例</p>
              <PatentRatioChart /> 
          </div>
          <div class="chart-box">
          <CityApplicantTypeChart />
          </div>
          </div>
      </el-col>
      <el-col :span="10">
        <div class="content-center">
          <HLJMapChart  />
          <!-- <div :style="{padding:'0 20px', marginTop: '-38px'}"> -->
            <!-- <TABLEDATA /> -->
            <!-- <div class="left-stats">
              <div class="stats-num">
                <div><p :style="{fontSize: '22px'}">4554</p><p>专利申请量</p></div>
                <div><p :style="{fontSize: '22px'}">1503</p><p>有效专利量</p></div>
                <div><p :style="{fontSize: '22px'}">2613</p><p>发明专利申请量</p></div>
                <div><p :style="{fontSize: '22px'}">854</p><p>有效发明专利量</p></div>
              </div>
            </div> -->
          <!-- </div> -->
          <div class="count">
            <div><p>6099</p><p>专利申请量</p><p></p></div>
            <div><p>2004</p><p>有效专利量</p><p></p></div>
            <div><p>3838</p><p>发明专利申请量</p><p></p></div>
            <div><p>1357</p><p>有效发明专利量</p><p></p></div>
            <!-- <div><p>23069</p><p>德国</p></div> -->
          </div>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="content-right">
          <div class="chart-branchRank">
            <TechBranchCityRankChart /> 
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="table-Operational">
      <TABLEDATA />
    </el-row>
    <div id="screen3-applyEchart" :style="{ width: '100%', height: '260px' }"></div>
</div>
</template>

<script>
import HLJMapChart  from './mapHljChart.vue'
import CityApplicantTypeChart from './cityApplicantTypeChart.vue'
import TechBranchCityRankChart from './techBranchCityRankChart.vue'
import TABLEDATA from './tableData.vue'
import PatentRatioChart from './patentRatioChart.vue'
import * as echarts from "echarts";
import { onMounted, onUnmounted } from 'vue'
export default {
  name: 'App',
  components: {
    HLJMapChart ,
    TABLEDATA,
    CityApplicantTypeChart,
    TechBranchCityRankChart,
    PatentRatioChart
  },
  data(){
    return {
    }
  },
  setup() {
   let echart = echarts;
    onMounted(() => {
    });
    onUnmounted(() => {
      echart.dispose();
    });
  }
}
</script>

<style scoped>
.tag{
  margin: 0 auto;
  margin-bottom: 10px;
}
.tag span{
  cursor: pointer;
  padding-right: 35px;
 }
 .tag span.active{
  color: #409eff;
  font-weight: 500;
 }
/deep/.el-select__wrapper {
    border: none;
    background: transparent!important;
}
/deep/.el-select__wrapper span{
    color: #fff;
}
.table-Operational{
  margin:  -30px auto;
  border: 2px solid rgba(51, 111, 255, .38);
     border: 1px solid #088DF2;
   box-shadow: 0px 0px 6px 1px #088df2;
}
</style>
